import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { TabelaPrecoSelectComponent } from './tabela-preco-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        TabelaPrecoSelectComponent
    ],
    exports: [
        TabelaPrecoSelectComponent
    ]
})
export class TabelaPrecoSelectModule { }
